/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Range } from 'react-range';
import setClass from '../../common/set-class';
function getTrackBackground({ values, colors, min, max }) {
    // sort values ascending
    const progress = values
        .slice(0)
        .sort((a, b) => a - b)
        .map((value) => ((value - min) / (max - min)) * 100);
    const middle = progress.reduce((acc, point, index) => `${acc}, ${colors[index]} ${point}%, ${colors[index + 1]} ${point}%`, '');
    return `linear-gradient(to right, ${colors[0]} 0%${middle}, ${colors[colors.length - 1]} 100%)`;
}
const Slider = ({ value, onChange, min, max, step, markersCount, getMarkerLabel, markedValues, error, disabled, style, className, }) => {
    const markedIndexes = useMemo(() => {
        if (markedValues) {
            return markedValues.map((theValue) => (theValue - min) / step);
        }
        const res = [0, (max - min) / step];
        for (let i = 1; i <= markersCount; i++) {
            res.push(Math.round(((max - min) / step / (markersCount + 1)) * i));
        }
        return res;
    }, [markedValues, min, max, step, markersCount]);
    return (React.createElement("div", { className: setClass('b-slider', className, error && '--error', disabled && '--disabled'), style: style },
        error && React.createElement("div", { className: "b-slider__error" },
            " ",
            error,
            " "),
        React.createElement(Range, { step: step, min: min, max: max, values: [value], disabled: disabled, onChange: (values) => onChange(values[0]), renderMark: ({ props, index }) => (React.createElement("div", { className: "b-slider__marker", ...props, style: {
                    ...props.style,
                    display: markedIndexes.indexOf(index) === -1 ? 'none' : 'block',
                } },
                React.createElement("div", { className: "b-slider__marker-label" }, getMarkerLabel(min + index * step)))), renderTrack: ({ props, children }) => (React.createElement("div", { onMouseDown: props.onMouseDown, onTouchStart: props.onTouchStart, style: {
                    ...props.style,
                    height: '36px',
                    display: 'flex',
                    width: '100%',
                } },
                React.createElement("div", { ref: props.ref, className: "b-slider__track-inner", style: {
                        background: getTrackBackground({
                            values: [value],
                            colors: [
                                disabled ? 'rgba(26, 29, 37, 0.6)' : '#0057DA',
                                'rgba(26, 29, 37, 0.15)',
                            ],
                            min,
                            max,
                        }),
                    } }, children))), renderThumb: ({ props }) => (React.createElement("svg", { ...props, width: "24", height: "28", viewBox: "0 0 24 28", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.8138 27.5361L1.72794 18.6292C0.617804 17.5409 0 16.1051 0 14.6134L0.0420302 2.93577C0.0420302 1.31439 1.34501 0 3.23644 0H20.8057C22.7812 0 24.0001 1.31439 24.0001 2.93577L23.9581 14.6134C23.9581 16.1051 23.3403 17.5409 22.2302 18.6292L13.1443 27.5361C12.541 28.1275 11.5302 28.1575 10.8867 27.603C10.8616 27.5814 10.8373 27.5591 10.8138 27.5361Z", fill: "white" }),
                React.createElement("path", { d: "M1.04202 2.93937H1.04203V2.93577C1.04203 1.91919 1.84327 1 3.23644 1H20.8057C21.5659 1 22.106 1.24883 22.4501 1.58016C22.795 1.91239 22.9997 2.38077 23.0001 2.93396C23.0001 2.93456 23.0001 2.93517 23.0001 2.93577L22.9581 14.6098V14.6134C22.9581 15.824 22.4574 17.006 21.5301 17.915L12.4442 26.822C12.2153 27.0464 11.7926 27.0636 11.5394 26.8454L11.5394 26.8454C11.5305 26.8377 11.522 26.8299 11.5139 26.822L10.8138 27.5361L11.5139 26.822L2.42798 17.915C1.50109 17.0064 1.00047 15.8251 1 14.6151C1 14.6145 1 14.6139 1 14.6134L1.04202 2.93937Z", stroke: "#1A1D25", strokeOpacity: "0.15", strokeWidth: "2" }))) })));
};
export default Slider;
Slider.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    markersCount: PropTypes.number,
    getMarkerLabel: PropTypes.func,
    markedValues: PropTypes.arrayOf(PropTypes.number),
    error: PropTypes.string,
    disabled: PropTypes.bool,
    style: PropTypes.object,
    className: PropTypes.string,
};
Slider.defaultProps = {
    min: 0,
    max: 100,
    step: 1,
    markersCount: 1,
    getMarkerLabel: (val) => val,
    disabled: false,
    markedValues: undefined,
    error: undefined,
    style: undefined,
    className: undefined,
};
